module.exports = __webpack_public_path__ + "mobile/img/huiTalk-img1.b597893a.png";